import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { notification, modal } from 'redux/modules/app'
import {
  adventurousJourney as adventurousJourneyApi
} from 'redux/modules/api/combineDashboard'
import { fetchAward, loadAward } from 'redux/modules/api/dashboard/awards'
import {
  schemaAJParticipantEvent,
  schemaPQJourneySetup,
  schemaTrainingCreate,
  schemaTrainingEdit
} from 'models/adventurousJourney'
import { schemaApproval, schemaAlreadyAssessed } from 'models/approvals'

function decorator(config = { loaders: [] }) {
  return ComposedComponent => {
    @connect(
      ({ api }) => {
        const loaders = {}

        config.loaders &&
          config.loaders.forEach(key => {
            loaders[`${key}Status`] = get(
              api,
              `dashboard.adventurousJourney['${key}']`
            )
          })

        return {
          ...loaders,
          aJValues: get(api, 'dashboard.adventurousJourney'),
          activeAwardId: get(api, 'dashboard.awards.awards.activeAwardId')
        }
      },
      {
        ...adventurousJourneyApi,
        notification,
        fetchAward,
        loadAward,
        modal,
        push
      }
    )
    class apiAdventurousJourney extends Component {
      static propTypes = {
        setupParticipantEventJourney: PropTypes.func.isRequired,
        awardId: PropTypes.any,
        completeAJParticipantEvent: PropTypes.func.isRequired,
        assessorRequestPE: PropTypes.func.isRequired,
        assessorLeaderPE: PropTypes.func.isRequired,
        signOffRequestPT: PropTypes.func.isRequired,
        getAJCategories: PropTypes.func.isRequired,
        editAJTraining: PropTypes.func.isRequired,
        getAwardDetail: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        getAJDetail: PropTypes.func.isRequired,
        getAJfiles: PropTypes.func.isRequired,
        fetchAward: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        getPTSignoff: PropTypes.func.isRequired,
        editAjEventDetail: PropTypes.func.isRequired,
        editAjEventAim: PropTypes.func.isRequired,
        ajEventAssessorRejection: PropTypes.func.isRequired
      }

      static defaultProps = {
        params: {}
      }

      componentDidMount() {
        config.loadCategories && this.handleGetAJCategories()
      }

      handleGetAwardDetail = id => {
        this.props
          .getAwardDetail(id)
          .then(
            ({ body } = {}) =>
              config.loadPTSignoffAction && this.handleGetPTSignoff(body)
          )
          .catch(err => {
            throw err
          })
      }

      handleGetAJDetail = id =>
        this.props.getAJDetail(id).catch(err => {
          throw err
        })

      handleGetAJCategories = awardLevel => {
        if (!awardLevel) {
          awardLevel = get(this.props, 'awards.data.awardLevel.value')
        }

        this.props.getAJCategories(awardLevel)
      }

      handleEditAjEventDetail = fields => {
        const { params, awardId } = this.props

        return this.props
          .editAjEventDetail(fields.id, fields)
          .then(() => this.props.getAwardDetail(params.awardId || awardId))
          .then(() => {
            this.handleSuccess(
              'Adventurous Journey has been modified',
              'notifications.adventurous_journey_modified',
              null,
              true
            )
          })
          .catch(this.handleError)
      }

      handleEditAjEventAim = (fields, ajPeId) => {
        const { params, awardId } = this.props

        return this.props
          .editAjEventAim(ajPeId, { aim: fields.aim })
          .then(() => this.props.getAwardDetail(params.awardId || awardId))
          .then(() => {
            this.handleSuccess(
              'Adventurous Journey has been modified',
              'notifications.adventurous_journey_modified',
              null,
              true
            )
          })
          .catch(this.handleError)
      }

      handleGetPTSignoff = data => {
        if (
          get(data, 'ajPreparationAndTrainingsSignoffActionId') &&
          get(data, 'id')
        ) {
          this.props.getPTSignoff(
            get(data, 'id'),
            get(data, 'ajPreparationAndTrainingsSignoffActionId')
          )
        }
      }

      handleSetupParticipantEventJourney = async (
        award,
        fields,
        { resetForm, eventCategory, pEId }
      ) => {
        try {
          await this.props.setupParticipantEventJourney(
            schemaPQJourneySetup(fields, { eventCategory, pEId, award })
          )
          return await this.handleSuccess(
            'New participant event has been added',
            'notifications.new_participant_event_has_been_added',
            resetForm
          )
        } catch (err) {
          this.handleError(err)
        }
      }

      handleCompleteAJParticipantEvent = (id, fields, { resetForm }) =>
        this.props
          .completeAJParticipantEvent(id, schemaAJParticipantEvent(id, fields))
          .then(() =>
            this.handleSuccess(
              'Participant event has been completed',
              'notifications.new_participant_event_has_been_completed',
              resetForm
            )
          )
          .catch(this.handleError)

      handleFetchAjFiles = awardId => this.props.getAJfiles(awardId)

      handleAssessorRequestPE = (id, fields, { resetForm }) => {
        this.props
          .assessorRequestPE(id, schemaApproval(fields))
          .then(() =>
            this.handleSuccess(
              'Assessment request has been sent',
              'notifications.assessment_request_sent',
              resetForm
            )
          )
          .catch(this.handleError)
      }

      handleAssessorLeaderPE = (id, fields, { resetForm }) => {
        this.props
          .assessorLeaderPE(id, schemaApproval(fields))
          .then(() =>
            this.handleSuccess(
              'Leader approval request has been sent',
              'notifications.already_assessed_sent',
              resetForm
            )
          )
          .catch(this.handleError)
      }

      handleSignOffRequestPT = id => {
        return this.props
          .signOffRequestPT(id)
          .then(() =>
            this.handleSuccess(
              'Preparation and training approval has been sent',
              'notifications.preparation_and_training_approval_sent'
            )
          )
          .catch(this.handleError)
      }

      handleSendAlreadyAssessed = (id, fields, { resetForm }) =>
        this.props
          .assessorLeaderPE(id, schemaAlreadyAssessed(fields))
          .then(() =>
            this.handleSuccess(
              'Leader approval request has been sent',
              'notifications.already_assessed_sent',
              resetForm
            )
          )
          .catch(this.handleError)

      handlePracticeAndTraining = (awardId, fields, { resetForm }) => {
        const payload = {
          array: [
            ...fields.def.map(item => schemaTrainingEdit(item)),
            ...fields.userAdded.map(item => schemaTrainingCreate(item))
          ]
        }

        return this.props
          .editAJTraining(awardId, payload)
          .then(() =>
            this.handleSuccess(
              'Training and Practice has been modified',
              'notifications.training_and_practice_modified',
              resetForm
            )
          )
          .catch(this.handleError)
      }

      handleSuccess = (
        text = 'Success',
        intlKey = 'notifications.success',
        resetForm
      ) => {
        this.props.notification(text, { status: 'success', intlKey })
        this.props.modal(null, null)
        // !noRefreshAward && this.handleRefreshAward()
        this.handleRefreshAJ()
        resetForm && resetForm()
      }

      handleError = err => {
        console.debug('error', err.body && err.body.userMessage)
        return this.props.notification(
          err.body &&
            (err.body.userMessage || err.body.developerMessage || 'Error'),
          'error'
        )
      }

      handleRefreshAJ = () =>
        get(this.props, config.refreshKey) &&
        this.props.getAwardDetail(get(this.props, config.refreshKey))

      handleRefreshAward = () => {
        const { params, awardId } = this.props
        const id = params.awardId || awardId

        id && this.props.fetchAward(id, { fetchAJ: true })
      }

      handleAjEventAssessorRejection = (ajId, fields) =>
        this.props
          .ajEventAssessorRejection(ajId, fields)
          .then(() =>
            this.props.notification('Adventurous Journey has been rejected', {
              status: 'success',
              intlKey: 'notifications.aj_has_been_rejected'
            })
          )
          .catch(this.handleError)

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onGetAJDetail={this.handleGetAJDetail}
            onEditAjEventDetail={this.handleEditAjEventDetail}
            onEditAjEventAim={this.handleEditAjEventAim}
            onGetAwardDetail={this.handleGetAwardDetail}
            onGetAJCategories={this.handleGetAJCategories}
            onSignOffRequestPT={this.handleSignOffRequestPT}
            onAssessorLeaderPE={this.handleAssessorLeaderPE}
            onAssessorRequestPE={this.handleAssessorRequestPE}
            onPracticeAndTraining={this.handlePracticeAndTraining}
            onSendAlreadyAssessed={this.handleSendAlreadyAssessed}
            onCompleteAJParticipantEvent={this.handleCompleteAJParticipantEvent}
            onFetchAjFiles={this.handleFetchAjFiles}
            onSetupParticipantEventJourney={
              this.handleSetupParticipantEventJourney
            }
            ajEventAssessorRejection={this.handleAjEventAssessorRejection}
          />
        )
      }
    }
    return apiAdventurousJourney
  }
}

export default decorator
